export const DragConfig = {
  forceAutoScrollFallback: true,
  scrollSensitivity: 100,
  scrollSpeed: 30,
} as const
